import styled from '@emotion/styled';
import { theme } from '../design-system';
import { useBreakpoints } from '../../../helpers/useBreakpoints';

const Slider = styled.input`
  -webkit-appearance: none;
  width: 55%;
  height: 0.25rem;
  background: ${theme.colors.neutralLight};
  outline: none;
  z-index: 10;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    cursor: pointer;
    width: ${({ thumbSize }) => thumbSize};
    height: ${({ thumbSize }) => thumbSize};
    border-radius: 50%;
    background-color: ${({ bgColor }) => bgColor};
  }

  &::-moz-range-thumb {
    cursor: pointer;
    width: ${({ thumbSize }) => thumbSize};
    height: ${({ thumbSize }) => thumbSize};
    border-radius: 50%;
    background-color: ${({ bgColor }) => bgColor};
  }
`;

const ImageZoomSlider = ({ value, onChange, id }) => {
  const { breakpoints } = useBreakpoints();
  return (
    <Slider
      type='range'
      thumbSize={breakpoints('0.75rem', '1rem', '1.25rem')}
      id={id}
      value={value}
      min={1}
      max={3}
      step={0.1}
      onChange={onChange}
      bgColor={theme.colors.primary}
    />
  );
};

export default ImageZoomSlider;
